import { FC, RefObject } from 'react';

import { ModalFormTableOfContents } from '@/shared';

import { AlertFormSectionKey, alertFormSteps } from '../../steps';

interface AlertFormStepsProps {
    scrollContainerRef: RefObject<HTMLDivElement | null>;
    onSelect: (section: AlertFormSectionKey) => void;
}

const AlertFormSteps: FC<AlertFormStepsProps> = ({ onSelect, scrollContainerRef }) => (
    <ModalFormTableOfContents
        items={alertFormSteps.map((step) => {
            const StepIcon = step.icon;

            return { icon: <StepIcon />, key: step.key, label: step.label };
        })}
        onSelect={(section) => {
            if (scrollContainerRef.current) {
                onSelect(section);
            }
        }}
    />
);

export default AlertFormSteps;
